import React from 'react';

import { Stack, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { EditableTextField } from '../components/EditableTextField';
import { UPDATE_FREE_TEXT } from './revisions.graphql';
import { useMutation } from '@apollo/client';
import { Revision } from './Details';
import { StyledPaper } from '../theme';

const helpText =
  'Her kan man legge inn en tekst som beskriver bakgrunnen for revisjonen. Det er spesielt aktuelt for begrensede revisjoner ' +
  'der man ikke oppretter nytt manus og mapper på intern server.';

export function RevisionFreeText({ revision, readonly }: { revision: Revision; readonly?: boolean }) {
  const [updateFreeText] = useMutation(UPDATE_FREE_TEXT);
  return (
    <StyledPaper>
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <Typography variant="h5" component="h3">
          Beskrivelse av revisjon
        </Typography>
        <Tooltip title={helpText}>
          <InfoOutlinedIcon fontSize="small" color="action" tabIndex={0} aria-label="Hva skal stå her?" />
        </Tooltip>
      </Stack>

      {readonly ? (
        revision?.freeText
      ) : (
        <EditableTextField
          value={revision?.freeText ?? ''}
          TextFieldProps={{
            multiline: true,
          }}
          onUpdate={async (value) => {
            await updateFreeText({ variables: { input: { id: revision?.id, text: value } } });
          }}
        />
      )}
    </StyledPaper>
  );
}
